import {Component, EventEmitter, Input, Output, OnChanges, SimpleChanges} from '@angular/core';
import {SalesConciergeRequest} from '../../../models/sales-concierge-request.model';
import {SalesConciergeProductCount} from '../../../enums/sales-concierge-product-count.enum';
import {SalesConciergeStep} from '../../../enums/sales-concierge-step.enum';


@Component({
    selector: 'sales-concierge-product-count-info.',
    templateUrl: './product-count-info.component.html',
    styleUrls: ['./product-count-info.component.scss']
})
export class SalesConciergeProductCountInfoComponent implements OnChanges {


    @Input() public salesConciergeRequest: SalesConciergeRequest;
    public salesConciergeProductCount = SalesConciergeProductCount;

    @Input() reset = false;
    @Output() salesConciergeStep = new EventEmitter<SalesConciergeStep>();
    @Output() salesConciergeNextStep = new EventEmitter<SalesConciergeStep>();

    public selectedProductCount;


    @Output()
    public selectedSalesConciergeRequest: EventEmitter<SalesConciergeRequest> = new EventEmitter<SalesConciergeRequest>();

    public constructor() {


    }


    public onPreviousBtnClicked() {

        this.salesConciergeRequest.productCountInfo = null;
        this.salesConciergeStep.emit(SalesConciergeStep.REQUEST_TYPE);
    }

    public ngOnChanges(change: SimpleChanges) {


        this.salesConciergeNextStep.emit(SalesConciergeStep.CUSTOMER_INFO);

        if (change['reset'] && change['reset'].currentValue) {


            if (this.salesConciergeRequest.productCountInfo !== null && this.salesConciergeRequest.productCountInfo !== undefined) {
                this.selectedProductCount = this.salesConciergeRequest.productCountInfo;
            } else {
                this.salesConciergeRequest.productCountInfo = this.getKeyByValue(SalesConciergeProductCount, SalesConciergeProductCount.NO_INFORMATION);
            }

        }

    }


    public getKeyByValue(EnumType: Object, value: any): string {
        return Object.keys(EnumType).find(key => EnumType[key] === value);
    }


    public setProductCountInfo(productCount: string) {
        this.selectedProductCount = productCount;

        const key = this.getKeyByValue(SalesConciergeProductCount, productCount);
        this.salesConciergeRequest.productCountInfo = key;
        this.selectedSalesConciergeRequest.emit(this.salesConciergeRequest);


    }

}
